// extracted by mini-css-extract-plugin
module.exports = {"filters":"QuestionFiltersMobile_filters__1TS0P","filter":"QuestionFiltersMobile_filter__3i81z"};